module.exports = __webpack_public_path__ + "media/images/flags/BA-617c524c2ea2d3c5d51d18896652d03a.svg";